/**
 * Miracle Balm quiz result injection — parity with legacy theme (my-test/product-hero.liquid).
 * Depends on: .js-productData (phn-quiz-product-data), .js-mbMiniProductData, shade-catalog (window.shadeCatalog).
 */
(function (global) {
  'use strict';

  global.JR = global.JR || {};

  function syncLiquidAjaxCart() {
    return new Promise(function (resolve) {
      if (global.liquidAjaxCart && typeof global.liquidAjaxCart.update === 'function') {
        global.liquidAjaxCart.update({}, { lastCallback: function () { resolve(); } });
      } else {
        resolve();
      }
    });
  }

  function refreshAjaxCartSectionsAsync() {
    var sections = document.querySelectorAll('[data-ajax-cart-section]');
    var jobs = Array.prototype.map.call(sections, function (cartEl) {
      var section = cartEl.closest('[id^="shopify-section-"]');
      if (!section) return Promise.resolve();
      var sid = section.id.replace('shopify-section-', '');
      return fetch((global.location.pathname || '/') + '?sections=' + sid)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data[sid]) return;
          var doc = new DOMParser().parseFromString(data[sid], 'text/html');
          var fresh = doc.querySelector('[data-ajax-cart-section]');
          if (fresh) cartEl.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
    return Promise.all(jobs);
  }

  /** MB quiz raw-fetch ATC: refresh drawer HTML before opening. */
  global.JR.refreshCartThenOpen = function refreshCartThenOpen() {
    return syncLiquidAjaxCart()
      .then(refreshAjaxCartSectionsAsync)
      .then(function () {
        global.dispatchEvent(new CustomEvent('cart-open'));
      });
  };

  var CHECKMARK_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="black"/><path d="M14.5 7L8.71025 12.834C8.49058 13.0553 8.13442 13.0553 7.91475 12.834L5.5 10.4008" stroke="black" stroke-linecap="round"/></svg>';

  function esc(s) {
    if (!s) return '';
    var el = document.createElement('span');
    el.textContent = s;
    return el.innerHTML;
  }

  function normalizeAboutKeys(am) {
    if (!am || typeof am !== 'object') return am;
    var o = Object.assign({}, am);
    if (o.skin_type != null && o.skinType == null) o.skinType = o.skin_type;
    if (o.skin_tone != null && o.skinTone == null) o.skinTone = o.skin_tone;
    if (o.main_use != null && o.mainUse == null) o.mainUse = o.main_use;
    if (o.color_tone != null && o.undertone == null) o.undertone = o.color_tone;
    if (o.colorTone != null && o.undertone == null) o.undertone = o.colorTone;
    if (o.undertone != null && typeof o.undertone === 'object') {
      if (o.undertone.value != null && o.undertone.value !== '') o.undertone = o.undertone.value;
      else if (o.undertone.label != null && o.undertone.label !== '') o.undertone = o.undertone.label;
    }
    return o;
  }

  function mergeAboutMatchFromPayload(d, base) {
    var match = normalizeAboutKeys(base && typeof base === 'object' ? Object.assign({}, base) : {}) || {};
    if (!match || typeof match !== 'object') match = {};

    function setIfMissing(key, val) {
      if (val == null || val === '') return;
      if (match[key] == null || match[key] === '') match[key] = val;
    }

    setIfMissing('skinType', d.skin_type != null ? d.skin_type : d.skinType);
    setIfMissing('skinTone', d.skin_tone != null ? d.skin_tone : d.skinTone);
    setIfMissing('mainUse', d.main_use != null ? d.main_use : d.mainUse);
    setIfMissing('undertone', d.undertone != null ? d.undertone : d.color_tone != null ? d.color_tone : d.colorTone);

    var ans = d.answers || d.responses || d.quiz_answers;
    if (ans && typeof ans === 'object') {
      for (var key in ans) {
        if (!Object.prototype.hasOwnProperty.call(ans, key)) continue;
        var lk = String(key).toLowerCase().replace(/[^a-z0-9]/g, '');
        var val = ans[key];
        if (val == null || val === '') continue;
        if (typeof val === 'object') {
          if (val.value != null && val.value !== '') val = val.value;
          else if (val.label != null && val.label !== '') val = val.label;
          else continue;
        }
        if (lk.indexOf('skintype') !== -1 || lk === 'skin') setIfMissing('skinType', val);
        else if (lk.indexOf('skintone') !== -1) setIfMissing('skinTone', val);
        else if (lk.indexOf('undertone') !== -1 || lk.indexOf('colortone') !== -1) setIfMissing('undertone', val);
        else if (lk.indexOf('mainuse') !== -1 || (lk.indexOf('main') !== -1 && lk.indexOf('use') !== -1)) {
          setIfMissing('mainUse', val);
        }
      }
    }

    match = normalizeAboutKeys(match);
    return Object.keys(match).length ? match : null;
  }

  function deriveAboutMatch(d) {
    var match = null;
    if (d.aboutMatch && typeof d.aboutMatch === 'object') {
      match = mergeAboutMatchFromPayload(d, d.aboutMatch);
    } else if (d.about_match && typeof d.about_match === 'object') {
      match = mergeAboutMatchFromPayload(d, d.about_match);
    }
    var nested = [d.profile, d.skin_profile, d.quiz_profile, d.match_profile, d.match, d.skinProfile];
    for (var j = 0; j < nested.length; j++) {
      if (nested[j] && typeof nested[j] === 'object' && Object.keys(nested[j]).length) {
        match = mergeAboutMatchFromPayload(d, match || nested[j]);
      }
    }
    if (!match) match = mergeAboutMatchFromPayload(d, null);
    return match;
  }

  function derivePrimaryShade(d) {
    if (d.primaryShade && typeof d.primaryShade === 'object') return d.primaryShade;
    if (d.primary_shade && typeof d.primary_shade === 'object') return d.primary_shade;
    var alt = d.recommendedShade || d.recommended_shade || d.shade || d.matching_shade;
    if (alt && typeof alt === 'object') return alt;
    return null;
  }

  function normalizeQuizResultPayload(raw) {
    if (!raw || typeof raw !== 'object') return raw;
    var d = Object.assign({}, raw);
    if (raw.data && typeof raw.data === 'object') {
      var inner = raw.data;
      if (inner.primaryShade || inner.aboutMatch || inner.primary_shade || inner.about_match || inner.answers) {
        d = Object.assign({}, d, inner);
      }
    }
    if (d.about_match && !d.aboutMatch) d.aboutMatch = d.about_match;
    if (d.primary_shade && !d.primaryShade) d.primaryShade = d.primary_shade;
    var derivedAm = deriveAboutMatch(d);
    if (derivedAm) d.aboutMatch = derivedAm;
    var derivedPs = derivePrimaryShade(d);
    if (derivedPs) d.primaryShade = derivedPs;
    var am = d.aboutMatch;
    if (am && typeof am === 'object') d.aboutMatch = normalizeAboutKeys(am);
    var ps = d.primaryShade;
    if (ps && typeof ps === 'object') {
      ps = Object.assign({}, ps);
      if (ps.why_this_works != null && ps.whyThisWorks == null) ps.whyThisWorks = ps.why_this_works;
      if (!ps.name && (ps.title || ps.shade_name || ps.shadeName)) {
        ps.name = ps.title || ps.shade_name || ps.shadeName;
      }
      d.primaryShade = ps;
    }
    return d;
  }

  function injectQuizHeading(data) {
    var h = document.querySelector('.quiz-results-intro__heading');
    if (!h) return;
    var userName = (data.userName || '').trim();
    h.textContent = userName ? userName + ', here are your personalized results' : 'Here are your personalized results';
  }

  function injectAboutMatch(heroEl, match, activeTestGroup) {
    if (!match) return;
    var items = [];
    var v2 = activeTestGroup === 'v2';
    if (match.skinType) items.push({ label: 'SKIN TYPE', value: match.skinType });
    if (match.skinTone) items.push({ label: 'SKIN TONE', value: match.skinTone });
    if (match.undertone) {
      var ut = (match.undertone + '').replace(/\s*undertone\s*/gi, '').trim();
      if (v2) ut = ut.toLowerCase().replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
      items.push({ label: v2 ? 'COLOR TONE' : 'UNDERTONE', value: ut });
    }
    if (match.mainUse) items.push({ label: 'MAIN USE', value: match.mainUse });
    if (items.length === 0) return;

    var iconImg = '<span class="quiz-rec-about__icon" aria-hidden="true">' + CHECKMARK_SVG + '</span>';

    var html =
      '<div class="quiz-rec-about">' +
      '<h3 class="quiz-rec-about__heading">ABOUT YOUR MATCH</h3>' +
      '<p class="quiz-rec-about__sub">Selected just for you based on your quiz answers:</p>';
    items.forEach(function (item) {
      html +=
        '<div class="quiz-rec-about__item">' +
        iconImg +
        '<span class="quiz-rec-about__label">' +
        esc(item.label) +
        ':</span> ' +
        '<span class="quiz-rec-about__value">' +
        esc(item.value) +
        '</span>' +
        '</div>';
    });
    html += '</div>';

    var info = heroEl.querySelector('.phn-info');
    if (info) {
      info.insertAdjacentHTML('afterbegin', html);
    } else {
      var sizeToggle = heroEl.querySelector('.mb-size-toggle');
      if (sizeToggle) sizeToggle.insertAdjacentHTML('beforebegin', html);
    }
  }

  function getSwatchColor(swatch) {
    if (!swatch) return '';
    if (typeof swatch === 'string') return swatch;
    if (swatch && typeof swatch.value === 'string') return swatch.value;
    if (swatch && typeof swatch.hex === 'string') return swatch.hex;
    return '';
  }

  function toSwatchString(val) {
    if (val == null) return '';
    if (typeof val === 'string') return val.trim();
    if (typeof val === 'object' && val !== null) {
      if (typeof val.value === 'string' && val.value.trim()) return val.value.trim();
      if (typeof val.hex === 'string' && val.hex.trim()) return val.hex.trim();
    }
    return '';
  }

  function parseSwatchStyleToStripHtml(style) {
    if (!style) return '';
    style = String(style).trim();
    if (!style) return '';

    var imgMatch = style.match(/background-image\s*:\s*url\(\s*['"]?([^'")]+)/i);
    if (imgMatch && imgMatch[1]) {
      return (
        '<span class="quiz-rec-shade__swatch-strip quiz-rec-shade__swatch-strip--img" style="background-image: url(' +
        esc(imgMatch[1]) +
        ')" aria-hidden="true"></span>'
      );
    }

    var colorMatch = style.match(/background-color\s*:\s*([^;]+)/i);
    if (colorMatch && colorMatch[1]) {
      return (
        '<span class="quiz-rec-shade__swatch-strip" style="background-color: ' +
        esc(colorMatch[1].trim()) +
        '" aria-hidden="true"></span>'
      );
    }

    var bgMatch = style.match(/background\s*:\s*([^;]+)/i);
    if (bgMatch && bgMatch[1] && !/url\(/i.test(bgMatch[1])) {
      return (
        '<span class="quiz-rec-shade__swatch-strip" style="background-color: ' +
        esc(bgMatch[1].trim()) +
        '" aria-hidden="true"></span>'
      );
    }

    return '';
  }

  function getSwatchStripFromDom(heroEl, variant, shadeName) {
    if (!heroEl) return '';
    var btn = null;

    if (variant && variant.id != null) {
      btn = heroEl.querySelector('[data-phn-std-shade][data-variant-id="' + variant.id + '"]');
    }

    var want = String(shadeName || (variant && variant.title) || '')
      .trim()
      .toLowerCase();
    if (!btn && want) {
      heroEl.querySelectorAll('[data-phn-std-shade]').forEach(function (b) {
        var title = (b.getAttribute('data-variant-title') || '').trim().toLowerCase();
        if (title === want) btn = b;
      });
    }

    if (!btn) return '';
    var inner = btn.querySelector('.phn-form-std__swatch-inner');
    if (!inner) return '';
    return parseSwatchStyleToStripHtml(inner.getAttribute('style') || '');
  }

  function getSwatchStrip(variant, heroEl, shadeName) {
    if (!variant && !shadeName) return '';

    var bg = variant ? toSwatchString(variant.swatch_bg) : '';
    var isImg = variant && (variant.swatch_is_img === true || variant.swatch_is_img === 'true');

    if (!bg && variant) {
      bg = getSwatchColor(variant.swatch);
    }

    if (bg) {
      if (isImg || /\.(jpg|jpeg|png|webp|gif)(\?|$)/i.test(bg)) {
        return (
          '<span class="quiz-rec-shade__swatch-strip quiz-rec-shade__swatch-strip--img" style="background-image: url(' +
          esc(bg) +
          ')" aria-hidden="true"></span>'
        );
      }
      return (
        '<span class="quiz-rec-shade__swatch-strip" style="background-color: ' + esc(bg) + '" aria-hidden="true"></span>'
      );
    }

    return getSwatchStripFromDom(heroEl, variant, shadeName);
  }

  function injectShadeCard(heroEl, shade, variant) {
    if (!shade || !shade.name) return;

    var swatchStrip = getSwatchStrip(variant, heroEl, shade.name);
    var desc = (variant && variant.description) ? variant.description : (shade.description || '');
    if (desc) {
      desc = desc.replace(/^\s*is\s+a\s+/i, '');
      if (desc) desc = 'A ' + desc;
    }
    var catalog = typeof global.shadeCatalog === 'object' ? global.shadeCatalog : {};
    var shadeTag = (shade.name && catalog[shade.name] && catalog[shade.name].category) ? catalog[shade.name].category : (shade.category || '');

    var html =
      '<div class="quiz-rec-shade">' +
      '<h3 class="quiz-rec-shade__heading">Your Shade</h3>' +
      '<div class="quiz-rec-shade__card">' +
      '<div class="quiz-rec-shade__info">' +
      '<div class="quiz-rec-shade__name-row">' +
      '<span class="quiz-rec-shade__name">' +
      esc(shade.name) +
      '</span>' +
      (shadeTag ? '<span class="quiz-rec-shade__tag">' + esc(shadeTag) + '</span>' : '') +
      '</div>' +
      (desc ? '<p class="quiz-rec-shade__desc">' + esc(desc) + '</p>' : '') +
      '</div>' +
      '<div class="quiz-rec-shade__qty">' +
      '<button type="button" class="quiz-rec-shade__qty-btn" data-quiz-qty-action="minus" aria-label="Decrease quantity"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M2 7h10"/></svg></button>' +
      '<span class="quiz-rec-shade__qty-val">1</span>' +
      '<button type="button" class="quiz-rec-shade__qty-btn" data-quiz-qty-action="plus" aria-label="Increase quantity"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round"><path d="M7 2v10M2 7h10"/></svg></button>' +
      '</div>' +
      swatchStrip +
      '</div>' +
      '</div>';

    var form = heroEl.querySelector('.js-productForm');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.classList.add('js-quizQuantity');
      qtyInput.value = '1';
    }

    var atcBtn = form.querySelector('.js-productFormPrimary');
    if (atcBtn) {
      atcBtn.insertAdjacentHTML('beforebegin', html);
    }

    if (!heroEl.__quizQtyListenerAdded) {
      heroEl.__quizQtyListenerAdded = true;
      heroEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-quiz-qty-action]');
        if (!btn) return;
        var action = btn.getAttribute('data-quiz-qty-action');
        var valEl = heroEl.querySelector('.quiz-rec-shade__qty-val');
        var input = heroEl.querySelector('.js-quizQuantity');
        var current = parseInt(valEl.textContent, 10) || 1;
        if (action === 'plus') current++;
        if (action === 'minus' && current > 1) current--;
        valEl.textContent = current;
        if (input) input.value = current;
      });
    }
  }

  function injectWhyThisWorks(heroEl, shade) {
    if (!shade) return;
    var text = shade.whyThisWorks || '';
    if (!text && shade.description) {
      text = shade.description;
    }
    if (!text) return;

    var html =
      '<div class="quiz-rec-why">' +
      '<h3 class="quiz-rec-why__heading">WHY THIS WORKS</h3>' +
      '<p class="quiz-rec-why__text">' +
      esc(text) +
      '</p>' +
      '</div>';

    var form = heroEl.querySelector('.js-productForm');
    if (!form) return;
    var atcBtn = form.querySelector('.js-productFormPrimary');
    if (atcBtn) {
      atcBtn.insertAdjacentHTML('beforebegin', html);
    }
  }

  function injectRecommendedTab(heroEl, data) {
    var names = [];
    if (data.primaryShade && data.primaryShade.name) names.push(data.primaryShade.name);
    if (data.alternateShades && data.alternateShades.length) {
      data.alternateShades.forEach(function (alt) {
        if (alt.name) names.push(alt.name);
      });
    }
    if (names.length === 0) return;
    var shadeNames = names
      .map(function (n) {
        return String(n).replace(/"/g, '&quot;');
      })
      .join(',');
    var namesLower = names.map(function (n) {
      return String(n).trim().toLowerCase();
    });

    function injectIntoContainer(container) {
      if (!container) return;
      var tabsUl = container.querySelector('.mb-set-builder__tabs');
      if (!tabsUl) return;
      var recBtn = tabsUl.querySelector('[data-category="recommended"]');
      if (recBtn) {
        recBtn.setAttribute('data-shade-names', shadeNames);
        container.querySelectorAll('.js-mbTab').forEach(function (t) {
          t.classList.remove('active');
        });
        recBtn.classList.add('active');
        container.querySelectorAll('.js-mbShadeCard').forEach(function (card) {
          var title = (card.getAttribute('data-variant-title') || '').toLowerCase();
          card.style.display = namesLower.indexOf(title) !== -1 ? '' : 'none';
        });
        return;
      }
      var li = document.createElement('li');
      li.innerHTML =
        '<button type="button" class="mb-set-builder__tab js-mbTab active" data-category="recommended" data-shade-names="' +
        shadeNames +
        '">RECOMMENDED</button>';
      tabsUl.insertBefore(li, tabsUl.firstChild);
      recBtn = tabsUl.querySelector('[data-category="recommended"]');
      if (recBtn) {
        container.querySelectorAll('.js-mbTab').forEach(function (t) {
          t.classList.remove('active');
        });
        recBtn.classList.add('active');
        container.querySelectorAll('.js-mbShadeCard').forEach(function (card) {
          var title = (card.getAttribute('data-variant-title') || '').toLowerCase();
          card.style.display = namesLower.indexOf(title) !== -1 ? '' : 'none';
        });
      }
    }

    var setBuilder = heroEl.querySelector('.js-mbSetBuilder');
    injectIntoContainer(setBuilder);

    var modal = document.querySelector('.js-mbUpsellModal');
    if (modal) {
      var modalContent = modal.querySelector('.mb-upsell-modal__content');
      injectIntoContainer(modalContent);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.dispatchEvent(new CustomEvent('mb-set-builder:check-scroll-hint'));
      });
    });
  }

  function injectAlternateShades(heroEl, alternates, miniData, productData) {
    if (!alternates || alternates.length === 0) return;
    alternates = alternates.slice(0, 2);

    var cardsHtml = '';
    alternates.forEach(function (alt) {
      var imageUrl = '';
      var stdVariantId = '';
      var miniVariantId = '';
      var priceStd = '';
      var priceMini = '';

      var themeDesc = '';
      if (productData && productData.variants) {
        var stdVariant = productData.variants.find(function (v) {
          return v.title.toLowerCase() === alt.name.toLowerCase();
        });
        if (stdVariant) {
          if (!imageUrl && stdVariant.media && stdVariant.media[0]) {
            imageUrl = stdVariant.media[0].src || '';
          }
          stdVariantId = stdVariant.id;
          if (stdVariant.price) priceStd = String(stdVariant.price);
          if (stdVariant.description) themeDesc = stdVariant.description;
        }
      }

      if (miniData && miniData.variants) {
        var miniVariant = miniData.variants.find(function (v) {
          return (v.title || '').toLowerCase() === alt.name.toLowerCase();
        });
        if (miniVariant) {
          if (!imageUrl && miniVariant.image) imageUrl = miniVariant.image;
          if (!imageUrl && miniVariant.media && miniVariant.media[0]) imageUrl = miniVariant.media[0].src;
          miniVariantId = miniVariant.id;
          if (miniVariant.price) priceMini = String(miniVariant.price);
        }
      }

      var defaultPrice = priceStd || priceMini || alt.price || '$34';
      var altDesc = themeDesc || alt.description || '';
      var catalog = typeof global.shadeCatalog === 'object' ? global.shadeCatalog : {};
      var altTag = (alt.name && catalog[alt.name] && catalog[alt.name].category) ? catalog[alt.name].category : (alt.category || '');

      cardsHtml +=
        '<div class="phn-paired-card quiz-rec-alt-card">' +
        '<div class="phn-paired-card__img">' +
        (imageUrl
          ? '<img src="' +
            esc(imageUrl) +
            '" alt="' +
            esc(alt.name) +
            '" width="152" height="152" loading="lazy" class="secondary-aspect-child">'
          : '') +
        '</div>' +
        '<div class="phn-paired-card__body">' +
        '<h3 class="phn-paired-card__title quiz-rec-alt-card__title">' +
        (alt.color
          ? '<span class="quiz-rec-alt-card__swatch-wrap"><span class="quiz-rec-alt-card__swatch quiz-rec-alt-card__swatch--inline" style="background-color: ' +
            esc(alt.color) +
            '"></span></span>'
          : '') +
        '<span>' +
        esc(alt.name) +
        '</span>' +
        (altTag ? '<span class="quiz-rec-alt-card__tag">' + esc(altTag) + '</span>' : '') +
        '</h3>' +
        (altDesc
          ? '<p class="quiz-rec-alt-card__desc"><strong>' +
            esc(alt.name) +
            '</strong> ' +
            esc(altDesc) +
            '</p>'
          : '') +
        '<button type="button" class="phn-paired-btn" data-quiz-alt-std="' +
        stdVariantId +
        '" data-quiz-alt-mini="' +
        miniVariantId +
        '" data-quiz-alt-price-std="' +
        esc(priceStd) +
        '" data-quiz-alt-price-mini="' +
        esc(priceMini) +
        '">' +
        '<span class="phn-paired-btn__text">Add To Bag</span>' +
        '<span class="phn-paired-btn__price js-quiz-alt-price">' +
        esc(defaultPrice) +
        '</span>' +
        '</button>' +
        '</div>' +
        '</div>';
    });

    var contentHtml =
      '<div class="product__description-upsells">' +
      '<p class="quiz-rec-alternates__sub">Because Miracle Balm is so versatile, more than one shade can work beautifully for you. Here are a few more we recommend:</p>' +
      '<div class="phn-paired-cards">' +
      cardsHtml +
      '</div>' +
      '</div>';

    var accordionHtml =
      '<div class="phn-accordion js-quiz-alt-shades-wrap">' +
      '<button type="button" class="phn-accordion__header js-quiz-alt-accordion" aria-expanded="true">' +
      '<span>Alternate Shades</span>' +
      '<span class="phn-accordion__icon" aria-hidden="true">−</span>' +
      '</button>' +
      '<div class="phn-accordion__body">' +
      '<div class="phn-accordion__content">' +
      contentHtml +
      '</div></div></div>';

    var accordions = heroEl.querySelector('.phn-accordions');
    var existingWrap = heroEl.querySelector('.js-quiz-alt-shades-wrap');
    if (existingWrap) existingWrap.remove();
    if (accordions) {
      accordions.insertAdjacentHTML('afterbegin', accordionHtml);
    } else {
      var info = heroEl.querySelector('.phn-info');
      if (info) info.insertAdjacentHTML('beforeend', '<div class="phn-accordions product__description-accordions">' + accordionHtml + '</div>');
    }

    var altAccordionBtn = heroEl.querySelector('.js-quiz-alt-accordion');
    if (altAccordionBtn && global.JR && typeof global.JR.initProductAccordion === 'function') {
      global.JR.initProductAccordion(altAccordionBtn);
    }

    function updateAlternateShadesPrices() {
      var activeSizeBtn = heroEl.querySelector('.js-mbSizeToggle.mb-size-toggle__btn--active');
      var isMini = activeSizeBtn && activeSizeBtn.getAttribute('data-size') === 'mini';
      var priceKey = isMini ? 'data-quiz-alt-price-mini' : 'data-quiz-alt-price-std';
      heroEl.querySelectorAll('.quiz-rec-alt-card .phn-paired-btn[data-quiz-alt-std]').forEach(function (btn) {
        var priceEl = btn.querySelector('.js-quiz-alt-price');
        if (!priceEl) return;
        var price = btn.getAttribute(priceKey);
        if (price == null || price === '') {
          price = btn.getAttribute(isMini ? 'data-quiz-alt-price-std' : 'data-quiz-alt-price-mini') || '';
        }
        priceEl.textContent = price;
      });
    }

    function updateAlternateShadesVisibility() {
      var wrap = heroEl.querySelector('.js-quiz-alt-shades-wrap');
      if (!wrap) return;
      var stdView = heroEl.querySelector('.js-mbStandardView');
      var isStandard = stdView && stdView.style.display !== 'none';
      wrap.style.display = isStandard ? '' : 'none';
    }
    updateAlternateShadesVisibility();
    updateAlternateShadesPrices();
  }

  function ensureQuizHeroDelegates(heroEl) {
    if (!heroEl || heroEl.__quizAltListenersAdded) return;
    heroEl.__quizAltListenersAdded = true;
    heroEl.addEventListener('click', function (e) {
      if (e.target.closest('.js-quiz-alt-accordion')) {
        var hdr = e.target.closest('.js-quiz-alt-accordion');
        if (!hdr) return;
        if (global.JR && typeof global.JR.toggleProductAccordion === 'function') {
          global.JR.toggleProductAccordion(hdr);
        }
        return;
      }

      if (e.target.closest('.js-mbSizeToggle')) {
        setTimeout(function () {
          var updateVis = heroEl.querySelector('.js-mbStandardView')
            ? heroEl.querySelector('.js-mbStandardView').style.display !== 'none'
            : false;
          var wrap = heroEl.querySelector('.js-quiz-alt-shades-wrap');
          if (wrap) wrap.style.display = updateVis ? '' : 'none';

          var activeSizeBtn = heroEl.querySelector('.js-mbSizeToggle.mb-size-toggle__btn--active');
          var isMini = activeSizeBtn && activeSizeBtn.getAttribute('data-size') === 'mini';
          var priceKey = isMini ? 'data-quiz-alt-price-mini' : 'data-quiz-alt-price-std';
          heroEl.querySelectorAll('.quiz-rec-alt-card .phn-paired-btn[data-quiz-alt-std]').forEach(function (btn) {
            var priceEl = btn.querySelector('.js-quiz-alt-price');
            if (!priceEl) return;
            var price = btn.getAttribute(priceKey);
            if (price == null || price === '') {
              price = btn.getAttribute(isMini ? 'data-quiz-alt-price-std' : 'data-quiz-alt-price-mini') || '';
            }
            priceEl.textContent = price;
          });
        }, 0);
      }
    });
    heroEl.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[name="mb-tier"]')) {
        var wrap = heroEl.querySelector('.js-quiz-alt-shades-wrap');
        if (!wrap) return;
        var stdView = heroEl.querySelector('.js-mbStandardView');
        var isStandard = stdView && stdView.style.display !== 'none';
        wrap.style.display = isStandard ? '' : 'none';
      }
    });
    heroEl.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('[data-quiz-alt-std]');
      if (!atcBtn) return;
      if (atcBtn.disabled) return;
      var activeSizeBtn = heroEl.querySelector('.js-mbSizeToggle.mb-size-toggle__btn--active');
      var isMini = activeSizeBtn && activeSizeBtn.getAttribute('data-size') === 'mini';
      var vid = isMini ? atcBtn.getAttribute('data-quiz-alt-mini') : atcBtn.getAttribute('data-quiz-alt-std');
      if (!vid) vid = atcBtn.getAttribute('data-quiz-alt-std') || atcBtn.getAttribute('data-quiz-alt-mini');
      if (!vid) return;

      var id = parseInt(vid, 10);
      if (isNaN(id)) return;

      e.preventDefault();
      atcBtn.disabled = true;
      var labelEl =
        atcBtn.querySelector('.phn-paired-btn__text') || atcBtn.querySelector('.product__upsell-label');
      if (labelEl) labelEl.textContent = 'ADDING...';

      function onDone() {
        if (labelEl) labelEl.textContent = 'ADDED!';
        atcBtn.classList.add('is-added');
        setTimeout(function () {
          if (labelEl) labelEl.textContent = 'Add To Bag';
          atcBtn.classList.remove('is-added');
          atcBtn.disabled = false;
        }, 2000);
      }
      function onFail() {
        if (labelEl) labelEl.textContent = 'Add To Bag';
        atcBtn.disabled = false;
      }

      if (typeof global.addToCart === 'function') {
        global.addToCart({ id: id, quantity: 1, properties: {} }, onDone);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return res.ok ? data : Promise.reject(data);
          });
        })
        .then(function () {
          var refreshThenOpen = global.JR && global.JR.refreshCartThenOpen;
          if (typeof refreshThenOpen === 'function') {
            return refreshThenOpen().then(onDone);
          }
          if (global.JR && typeof global.JR.refreshAjaxCartSections === 'function') {
            global.JR.refreshAjaxCartSections();
          }
          global.dispatchEvent(new CustomEvent('cart-open'));
          onDone();
        })
        .catch(function () {
          onFail();
        });
    });
  }

  function preselectVariant(heroEl, variant) {
    if (!variant || variant.id == null) return;
    var wrap = heroEl.querySelector('[data-phn-form-std]');
    if (!wrap) return;

    var vid = String(variant.id);
    var btn = wrap.querySelector('[data-phn-std-shade][data-variant-id="' + vid + '"]');
    if ((!btn || btn.hidden || btn.disabled) && variant.title) {
      var want = String(variant.title).trim().toLowerCase();
      wrap.querySelectorAll('[data-phn-std-shade]').forEach(function (b) {
        var t = (b.getAttribute('data-variant-title') || '').trim().toLowerCase();
        if (t === want && !b.disabled) btn = b;
      });
    }
    if (!btn || btn.disabled) return;

    var allTab = wrap.querySelector('[data-phn-std-tab][data-category="all"]');
    if (allTab && btn.hidden) {
      allTab.click();
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        btn.click();
      });
    });
  }

  function collapseFirstDescriptionAccordion(heroEl) {
    var descAcc =
      heroEl.querySelector('.phn-accordions .phn-accordion[data-phn-quiz-description]') ||
      heroEl.querySelector('.phn-accordions .phn-accordion:first-child');
    if (!descAcc) return;
    var btn = descAcc.querySelector('.phn-accordion__header');
    if (!btn) return;
    if (global.JR && typeof global.JR.setProductAccordionExpanded === 'function') {
      global.JR.setProductAccordionExpanded(btn, false);
    }
  }

  function onQuizResultsReady(evt) {
    var data = normalizeQuizResultPayload(evt.detail);
    if (!data) return;

    var heroEl = document.querySelector('[data-quiz-recommendations-target]');
    if (!heroEl) return;

    document.body.classList.remove('state--mini-view');

    var productDataEl = heroEl.querySelector('.js-productData');
    if (!productDataEl) return;

    var productData;
    try {
      var raw = productDataEl.textContent.trim();
      productData = JSON.parse(raw);
    } catch (e) {
      console.error('Quiz rec: failed to parse product data', e);
      return;
    }

    var miniDataEl = heroEl.querySelector('.js-mbMiniProductData') || document.querySelector('.js-mbMiniProductData');
    var miniData = null;
    if (miniDataEl) {
      try {
        miniData = JSON.parse(miniDataEl.textContent);
      } catch (e) {}
    }

    var std = heroEl.querySelector('.js-mbStandardView');
    var mini = heroEl.querySelector('.js-mbMiniView');
    if (std && mini) {
      std.style.display = '';
      mini.style.display = 'none';
      heroEl.querySelectorAll('.js-mbSizeToggle').forEach(function (b) {
        var isStd = b.getAttribute('data-size') === 'standard';
        b.classList.toggle('mb-size-toggle__btn--active', isStd);
        b.setAttribute('aria-pressed', isStd ? 'true' : 'false');
      });
    }

    var matchedVariant = null;
    if (data.primaryShade && data.primaryShade.name) {
      var shadeLower = data.primaryShade.name.toLowerCase();
      matchedVariant = productData.variants.find(function (v) {
        return v.title.toLowerCase() === shadeLower;
      });
    }

    document.querySelectorAll('.quiz-pending').forEach(function (el) {
      el.classList.remove('quiz-pending');
      el.classList.add('quiz-mode');
    });

    heroEl.querySelectorAll('.quiz-rec-about, .quiz-rec-shade, .quiz-rec-why').forEach(function (el) {
      el.remove();
    });

    ensureQuizHeroDelegates(heroEl);

    injectQuizHeading(data);
    injectAboutMatch(heroEl, data.aboutMatch, data.activeTestGroup);
    injectShadeCard(heroEl, data.primaryShade, matchedVariant);
    injectWhyThisWorks(heroEl, data.primaryShade);
    injectAlternateShades(heroEl, data.alternateShades, miniData, productData);
    injectRecommendedTab(heroEl, data);

    collapseFirstDescriptionAccordion(heroEl);

    if (matchedVariant) {
      preselectVariant(heroEl, matchedVariant);
    }

    document.body.classList.add('quiz-recommendations-ready');
  }

  function onQuizResultsReset() {
    var heroEl = document.querySelector('[data-quiz-recommendations-target]');
    if (!heroEl) return;

    document.querySelectorAll('.quiz-mode').forEach(function (el) {
      el.classList.remove('quiz-mode');
      el.classList.add('quiz-pending');
    });

    var aboutBlock = heroEl.querySelector('.quiz-rec-about');
    if (aboutBlock) aboutBlock.remove();

    var shadeBlock = heroEl.querySelector('.quiz-rec-shade');
    if (shadeBlock) shadeBlock.remove();

    var qtyInput = heroEl.querySelector('input.js-quizQuantity');
    if (qtyInput) {
      qtyInput.classList.remove('js-quizQuantity');
      qtyInput.value = '1';
    }

    var whyBlock = heroEl.querySelector('.quiz-rec-why');
    if (whyBlock) whyBlock.remove();

    var altWrap = heroEl.querySelector('.js-quiz-alt-shades-wrap');
    if (altWrap) altWrap.remove();

    var setBuilder = heroEl.querySelector('.js-mbSetBuilder');
    if (setBuilder) {
      var recTab = setBuilder.querySelector('.mb-set-builder__tabs [data-category="recommended"]');
      if (recTab) recTab.closest('li').remove();
      setBuilder.querySelectorAll('.js-mbShadeCard').forEach(function (card) {
        card.style.display = '';
      });
    }

    var modal = document.querySelector('.js-mbUpsellModal');
    if (modal) {
      var modalContent = modal.querySelector('.mb-upsell-modal__content');
      if (modalContent) {
        var modalRecTab = modalContent.querySelector('.mb-set-builder__tabs [data-category="recommended"]');
        if (modalRecTab) modalRecTab.closest('li').remove();
        modalContent.querySelectorAll('.js-mbShadeCard').forEach(function (card) {
          card.style.display = '';
        });
      }
    }

    var introHeading = document.querySelector('.quiz-results-intro__heading');
    if (introHeading) {
      introHeading.textContent = 'Here are your personalized results';
    }

    var descAcc = heroEl.querySelector('.phn-accordions .phn-accordion[data-phn-quiz-description]');
    if (descAcc) {
      var btn = descAcc.querySelector('.phn-accordion__header');
      if (btn && global.JR && typeof global.JR.setProductAccordionExpanded === 'function') {
        global.JR.setProductAccordionExpanded(btn, true);
      }
    }

    document.body.classList.remove('quiz-recommendations-ready');
    document.body.classList.remove('quiz-flow-results-mode');
  }

  function mount() {
    var win = global;
    if (win.__quizHeroReadyHandler) {
      document.removeEventListener('quiz:results-ready', win.__quizHeroReadyHandler);
      win.__quizHeroReadyHandler = null;
    }
    if (win.__quizHeroResetHandler) {
      document.removeEventListener('quiz:results-reset', win.__quizHeroResetHandler);
      win.__quizHeroResetHandler = null;
    }

    win.__quizHeroReadyHandler = onQuizResultsReady;
    win.__quizHeroResetHandler = onQuizResultsReset;
    document.addEventListener('quiz:results-ready', onQuizResultsReady);
    document.addEventListener('quiz:results-reset', onQuizResultsReset);
  }

  global.PhnMiracleBalmQuiz = { mount: mount };

  (function autoMountQuizRecMb() {
    function run() {
      mount();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
})(typeof window !== 'undefined' ? window : this);
